export { default as StoreLocatorMap } from './map';
